import { render, staticRenderFns } from "./ReceiptTemplateDialog.vue?vue&type=template&id=208245d3&scoped=true&"
import script from "./ReceiptTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./ReceiptTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208245d3",
  null
  
)

export default component.exports